import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Button } from '@/components/ui/button';
import { toast } from 'sonner';

export default function AdminLoginPage() {
  const [credentials, setCredentials] = useState({ username: '', password: '' });
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const backendUrl = process.env.REACT_APP_BACKEND_URL;
      const response = await fetch(`${backendUrl}/api/admin/login`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(credentials)
      });

      if (response.ok) {
        sessionStorage.setItem('admin_auth', 'true');
        toast.success('Login successful');
        navigate('/admin/home');
      } else {
        toast.error('Invalid credentials');
      }
    } catch (err) {
      toast.error('Login failed');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[hsl(var(--bk-bg))] flex items-center justify-center p-4">
      <div className="w-full max-w-md">
        <div className="text-center mb-8">
          <h1 className="font-display text-3xl text-[hsl(var(--bk-fg))] mb-2">BAKLIGHT Admin</h1>
          <p className="font-body text-sm text-[hsl(var(--bk-fg-muted))]">Content Management System</p>
        </div>

        <div className="bg-[hsl(var(--bk-bg-elev))] border border-[hsl(var(--bk-line))] rounded-lg p-8">
          <form onSubmit={handleLogin} className="space-y-6">
            <div>
              <Label className="font-mono-meta text-[hsl(var(--bk-fg-subtle))] mb-2">Username</Label>
              <Input
                value={credentials.username}
                onChange={(e) => setCredentials({...credentials, username: e.target.value})}
                className="bg-[hsl(var(--bk-bg))] border-[hsl(var(--bk-line))] text-[hsl(var(--bk-fg))]"
                required
              />
            </div>

            <div>
              <Label className="font-mono-meta text-[hsl(var(--bk-fg-subtle))] mb-2">Password</Label>
              <Input
                type="password"
                value={credentials.password}
                onChange={(e) => setCredentials({...credentials, password: e.target.value})}
                className="bg-[hsl(var(--bk-bg))] border-[hsl(var(--bk-line))] text-[hsl(var(--bk-fg))]"
                required
              />
            </div>

            <Button
              type="submit"
              disabled={loading}
              className="w-full bg-[hsl(var(--bk-accent))] text-[hsl(var(--bk-bg))] hover:opacity-90"
            >
              {loading ? 'Logging in...' : 'Login'}
            </Button>
          </form>
        </div>
      </div>
    </div>
  );
}
